// This is the core Cipher generation code.

var cipherObj = {
  "A": "1", "B": "2", "C": "3", "D": "4", "E": "5", "F": "6",
  "G": "7",
  "H": "6", "I": "5", "J": "4", "K": "3", "L": "2", "M": "1",
  "N": "1", "O": "2", "P": "3", "Q": "4", "R": "5", "S": "6",
  "T": "7",
  "U": "6", "V": "5", "W": "4", "X": "3", "Y": "2", "Z": "1"
};

// Check if input letter is actually a letter.
function isLetter(str) {
  return str.length === 1 && str.match(/[a-z]/i);
}

$(document).ready(function () {

  $(".cipherInput").each(function () {
    $(this).val(''); // Clear input box as we are starting again.
  });

  $('.cipherInput').on('input', function () {
    var cipherMessage = $(this).val();
    window.theme.invokeCipherCalculation(cipherMessage, $(this).closest("#cipherInputContainer"));
  });

  // COLOR SWATCH AND EDITOR INPUT
  // TODO: REFACTOR
  setTimeout(() => {
    $('.cipherInput').trigger('input');
    var color = localStorage.getItem('color');

    if (color) {
      var colorOption = $('.single-option-selector__radio[data-value="' + color + '"]');

      $('.single-option-selector__radio[name="Color"]').on('click', function () {
        var color = $(this).data('value');
        $('.color-div').text('*' + $(this).val());
        $('[data-img-alt]').hide();
        console.log(color);

        $('[data-img-alt]').each(function (i, image) {
          var imgAlt = $(image).data('img-alt');
          if (imgAlt == color) {
            $(image).show();
          }
        });

        var src = $('.js-image-switch:visible').eq(0).data('src');
        $('#ProductPhotoImg').attr('src', src);
        localStorage.setItem('color', color);

        $('#shopify-section-product-template-create').addClass('loaded');
      });

      colorOption.trigger('click');
    }

    $('.js-image-switch').click(function () {
      var src = $(this).data('src');
      var handle = $(this).data('handle');
      var back = $(this).data('back');

      $('#ProductPhotoImg').attr('src', src);
      console.log(back, handle);
      $('#circle-container, #circle-container-2, #circle-container-3').hide();

      setTimeout(function () {
        if (back && handle == "custom-bracelet") {
          $('#circle-container, #circle-container-2, #circle-container-3').hide();
        }
        else if (handle == "custom-bracelet") {
          $('#circle-container, #circle-container-2, #circle-container-3').show();
        }

        if (back && handle == "custom-series-1-cypher-bracelet-v2") {
          $('#circle-container, #circle-container-2').hide();
          $('#circle-container-3').show();
        }
        else if (handle == "custom-series-1-cypher-bracelet-v2") {
          $('#circle-container, #circle-container-2').show();
          $('#circle-container-3').hide();
        }
      }, 250);
    });
  }, 500);
  // END COLOR SWATCH AND EDITOR INPUT

  // READY TO WEAR:
  if ($('.cipherInput').data("ready-to-wear")) {
    var mess = $('.cipherInput').data("ready-to-wear").split('=')[0];
    console.log(mess);

    $('.cipherInput').val(mess);
    $('.cipherInput').attr('disabled', true);

    setTimeout(() => {
      $('.cipherInput')[0]?.dispatchEvent(new Event('input', { bubbles: true }));
    }, 1000);

    window.theme.invokeCipherCalculation(
      mess,
      $('.cipherInput').closest("#cipherInputContainer")
    );
  }

  $('.js-CreateButton').click(function (event) {
    event.preventDefault();

    if ($(this).data("cipher-product")) {
      var currentMessage = $('.cipherInput[data-cipher-product="' + $(this).data("cipher-product") + '"]').val().toUpperCase();
      localStorage.setItem("cipherMessage", currentMessage);
    }
    else {
      var container = $(this).closest('.editor');
      var currentMessage = $('.cipherInput', container).val().toUpperCase();
      localStorage.setItem("cipherMessage", currentMessage);

      var color = $('.variantSwatch.active', container).data('color');
      localStorage.setItem("color", color);

      $("input[name='cipherTextInput']", container).val(currentMessage).trigger("input");
    }

    if (event.target.href) {
      window.location.href = event.target.href;
    }
  });
});

window.theme.invokeCipherCalculation = function (message, container) {
  var $container = $(container);
  if (!$container.length) return;

  var inputString = String(message || '').toUpperCase();
  var arrayOfLetters = inputString.split('');
  var outputString = '';
  var sumOfCipherOutput = 0;

  for (var i = 0; i < arrayOfLetters.length; i++) {
    var char = arrayOfLetters[i];

    if (isLetter(char)) {
      var correspondingNumber = cipherObj[char];
      outputString += correspondingNumber;
      sumOfCipherOutput += parseInt(correspondingNumber, 10);
    }
    else if (char === " ") {
      outputString += " ";
    }
  }

  $('.cipherOutput', $container).html('<span class="cipherOutputText"></span>');
  $('.cipherOutputText', $container).text(outputString);

  $('.cipherOutputHidden', $container).val(outputString);
  $('.cipherOutputMessageHidden', $container).val($('.cipherInput', $container).val().toUpperCase());

  if (inputString.length === 0) {
    $('.cipherOutputSum', $container).html('');
    $('.cipherOutputSumHidden', $container).val('');
  } else {
    $('.cipherOutputSum', $container).html(sumOfCipherOutput.toString());
    $('.cipherOutputSumHidden', $container).val(sumOfCipherOutput);
  }
};